<div class="bar"
     [class.mat-elevation-z2]="2>1 || hasScrolled" [class.has-side-menu]="hasSideMenu">
    <div class="left" [class.logo-hideable]="!logoAlwaysDisplayed" (click)="onHeaderClicked()">
        <img class="logo" [src]="conf.assetsUrl + 'img/header-logo.png'" />
        <img class="logo-compact" [src]="conf.assetsUrl + 'img/header-logo.png'" />
    </div>
    <div class="right">
        <button (click)="onMobileChatClicked()" mat-mini-fab class="fab" color="default" [matTooltip]="'Chat' | translate">
            <mat-icon color="primary">chat_bubble_outline</mat-icon>
            <!--<mat-icon *ngIf="totalUnseenMessages > 0" color="primary" matBadge="{{ totalUnseenMessages }}" matBadgePosition="before" matBadgeColor="accent">chat_bubble_outline</mat-icon>
            <mat-icon *ngIf="totalUnseenMessages <= 0" color="primary">chat_bubble_outline</mat-icon>-->

            <div class="counter background-color-warn" *ngIf="(chatCounterService.totalUnseen$ | async) as total">
                {{ total }}
            </div>
        </button>

        <button mat-mini-fab
                class="fab"
                [matTooltip]="'Language' | translate"
                [matMenuTriggerFor]="langMenu">
            <mat-icon color="primary">language</mat-icon>
        </button>
        <mat-menu #langMenu="matMenu" xPosition="before">
            <button mat-menu-item
                class="menu-button"
                *ngFor="let lang of availableLangs"
                (click)="onLangClicked(lang.id)">
            {{ lang.shortName }}
            </button>
        </mat-menu>

        <button mat-mini-fab class="fab" color="default" (click)="sidenavService.toggleSidenav.emit()">
            <mat-icon color="primary">menu</mat-icon>
        </button>
    </div>
</div>
